/**
 * The credit amount of retailer small business grant program.
 */ export var OWF_GRANT_CREDITS_BY_COUNTRY = 'OWF_GRANT_CREDITS_BY_COUNTRY';
